import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/the-analytics-stack-we-actually-use")(blogRouteOptions("the-analytics-stack-we-actually-use"));
